module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/chicken-english.1c1fa34f.jpg";